'use client';

import { useEffect, useRef } from 'react';

import {
  IS_RUNNING_SERVER_SIDE,
  IS_PROD_ENVIRONMENT,
  IS_GHOST_ACCOUNT,
} from '@/config/app.config';
import { initLogRocket } from '@/lib/logrocket';
import initSentry from '@/lib/sentry';

const PreAuthInitializers = () => {
  const isInitialized = useRef(false);

  useEffect(() => {
    if (
      IS_RUNNING_SERVER_SIDE ||
      !IS_PROD_ENVIRONMENT ||
      IS_GHOST_ACCOUNT ||
      isInitialized.current
    ) {
      return;
    }

    isInitialized.current = true;
    initLogRocket();
    initSentry();
  }, []);

  return null;
};

export default PreAuthInitializers;
